import React, { useState } from 'react';

/**
 * PanelOutputFlyout - Panel çıkışı için flyout alt menü
 * GT panelinde çoklu alt panel seçimi, tek tip ise doğrudan buton
 * @param {{ childPanelTypes: Array, panelTypeId: string, onAddPanel: function }} props
 */
export default function PanelOutputFlyout({ childPanelTypes, panelTypeId, onAddPanel }) {
  const [showFlyout, setShowFlyout] = useState(false);

  // Tek alt panel tipi varsa doğrudan buton göster
  if (childPanelTypes.length === 1) {
    const child = childPanelTypes[0];
    return (
      <button
        onClick={() => onAddPanel(child)}
        className="my-button"
        style={{ textAlign: 'left', fontSize: '13px' }}
      >
        Ek Pano ({child.label})
      </button>
    );
  }

  // Alt panel tipi yoksa hiç gösterme
  if (childPanelTypes.length === 0) {
    return null;
  }

  // Birden fazla alt panel tipi (GT gibi) - flyout menü göster
  return (
    <div
      className="flyout-container"
      onMouseEnter={() => setShowFlyout(true)}
      onMouseLeave={() => setShowFlyout(false)}
    >
      <button
        className="my-button flyout-trigger"
      >
        Panel Ekle <span className="flyout-arrow">&#9658;</span>
      </button>
      {showFlyout && (
        <div className="flyout-menu">
          {childPanelTypes.map((child) => (
            <button
              key={child.id}
              onClick={() => onAddPanel(child)}
              className="my-button"
              style={{ textAlign: 'left', fontSize: '12px' }}
            >
              {child.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
